import React, { useRef } from 'react';
import Select from "react-select";
import { Controller, useController } from "react-hook-form";

const SearchableSelect = ({
    control,
    errors,
    optionList,
    name,
    isDisabled = false,
    placeholder,
    OptionLoading = false,
    isMulti = false,
    tabIndex = null,
    isSelectAll = false
}) => {

    const selectRef = useRef(null);

    const { field: { value: editValue, onChange: langOnChange, ...restLangField } } = useController({ name: name, control });

    return (
        <Controller
            name={name}
            control={control}
            className={errors ? "select-input error" : "select-input"}
            render={() => (
                <Select
                    isDisabled={isDisabled}
                    placeholder={errors ? errors.message : placeholder}
                    isMulti={isMulti}
                    isSelectAll={isSelectAll}
                    isClearable
                    options={optionList}
                    className={errors ? "react_select error" : "react_select"}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.id}
                    value={
                        editValue !== undefined && optionList?.length > 0
                          ? optionList.find((x) => x.id === editValue) || null
                          : null
                      }
                    onChange={(option) => langOnChange(option ? option.id : option)}
                    isLoading={OptionLoading}
                    menuPlacement="auto"
                    tabIndex={tabIndex}
                />
            )}
        />
    );
};

export default SearchableSelect;
